export default { initialize() {}, connectToDevTools() {} }
